import type { OnboardingReferenceData } from "@/app/onboarding/_lib/reference-data";

export function getDistricts(
	referenceData: OnboardingReferenceData,
	state: string,
) {
	return referenceData.districtsByState[state] ?? [];
}
